<template>
  <div class="register-interest-modal">
    <CustomModal :show="show"
                 @close="onCancel">
      <template #header>
        <h1 class="custom-modal__heading">
          Register interest
        </h1>
      </template>
      <div class="register-interest-modal__body">
        <template v-if="loading">
          <div class="register-interest-modal__loading-container">
            <div class="register-interest-modal__loading-content">
              <h5>Loading</h5>
              <font-awesome-icon icon="spinner"
                                 class="icon"
                                 size="lg"
                                 spin></font-awesome-icon>
            </div>
          </div>
        </template>

        <template v-else>
          <template v-if="metaData && metaData.length > 0">
            <MetaData v-model="metaData"></MetaData>
          </template>
          <template v-else>
            <p>No metadata found!</p>
          </template>

          <div class="register-interest-modal__action-buttons">
            <button class="btn"
                    :disabled="loading || submitting"
                    @click="onCancel">
              <template v-if="cancelling">
                <font-awesome-icon icon="spinner"
                                   spin></font-awesome-icon>
              </template>
              <template v-else>
                Cancel
              </template>
            </button>
            <button class="btn btn-accent-1"
                    :disabled="loading || cancelling"
                    @click="onSubmit">
              <template v-if="submitting">
                <font-awesome-icon icon="spinner"
                                   spin></font-awesome-icon>
              </template>
              <template v-else>
                Submit
              </template>
            </button>
          </div>
        </template>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import { getModalData, save } from "~/Scripts/resources/registerInterestResource";
import CustomModal from "~/Components/CustomModal.vue";
import MetaData from "~/Components/MetaData/MetaData.vue";

export default {
  name: "RegisterInterestModal",
  components: {
    CustomModal,
    MetaData
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    productId: {
      type: Number,
      default: null
    },
    pricingScheduleId: {
      type: Number,
      default: null
    },
    webAccountId: {
      type: String,
      default: null
    },
    orgId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      activity: {},
      orderHeader: {},
      cancelling: false,
      submitting: false,
      metaData: [],
      loading: false
    };
  },
  watch: {
    show: {
      immediate: true,
      handler ( val ) {
        if ( val ) {
          this.cancelling = false;
          this.submitting = false;
          this.loading = true;

          getModalData()
            .then( ( result ) => {
              this.activity = result.data.activityData;
              this.metaData = result.data.activityMetaData;
            } )
            .catch( ( error ) => {
              console.log( "an error occured when loading modal data" );
              throw error;
            } )
            .finally( () => {
              this.loading = false;
            } );
        }
      }
    }
  },
  methods: {
    onSubmit () {
      if ( !this.submitting ) {
        this.submitting = true;

        const modalData = {
          activityData: this.activity,
          activityMetaData: this.metaData
        };

        save( this.productId, modalData )
          .then( ( result ) => {
            if ( result && result.data ) {
              this.$emit( "close" );
            }
          } ).catch( ( error ) => {
            console.log( "error saving the price on application request" );
            throw error;
          } ).finally( () => {
            this.submitting = false;
          } );
      }
    },
    onCancel () {
      if ( !this.cancelling && !this.submitting ) {
        this.cancelling = true;
        this.$emit( "close" );
        this.cancelling = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.register-interest-modal {
  &__body {
    position: relative;
  }

  &__action-buttons {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
  }

  &__loading-container {
    display: flex;
    justify-content: center;
    height: 100px;
  }

  &__loading-content {
    display: flex;
    align-items: center;

    h5 {
      margin-bottom: 0;
    }

    .icon {
      margin: 10px;
    }
  }
}
</style>
